import { Link } from 'react-router-dom';
import type { Project } from '@/types/content';
import { deriveVariants } from '@/lib/media';

interface GalleryCardProps {
  project: Project;
  priority?: boolean;
  /** Index in the gallery, used for slight rhythm variation. */
  index?: number;
}

export function GalleryCard({ project, priority = false, index = 0 }: GalleryCardProps) {
  const v = deriveVariants(project.heroImage);
  const tall = index % 3 === 1;

  return (
    <article className={`gallery-card ${tall ? 'gallery-card--tall' : ''}`}>
      <Link to={`/projects/${project.slug}`} className="gallery-card__link">
        <figure className="gallery-card__figure">
          <picture>
            {v.avif ? <source srcSet={v.avif} type="image/avif" /> : null}
            {v.webp ? <source srcSet={v.webp} type="image/webp" /> : null}
            <img
              src={v.fallback}
              alt={project.heroAlt}
              loading={priority ? 'eager' : 'lazy'}
              decoding="async"
              {...(priority ? { fetchPriority: 'high' as const } : {})}
            />
          </picture>
          <div className="gallery-card__overlay" aria-hidden="true">
            <span className="gallery-card__view">View project</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M1 13L13 1M13 1H4M13 1V10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
            </svg>
          </div>
        </figure>
        <div className="gallery-card__meta">
          <p className="eyebrow">{project.typology} · {project.location} · {project.year}</p>
          <h3 className="gallery-card__title">{project.title}</h3>
          <p className="gallery-card__summary caption">{project.summary}</p>
        </div>
      </Link>
    </article>
  );
}
